export const buttonSizes = {
  small: "w-[112px] h-[44px] text-base",
  medium: "w-[180px] h-[48px] text-base",
};
